import { AddressValidator } from '$shared/helpers/validators/AddressValidator';
import AddressType from '$provider/lib/apis/models/AddressType';
import { schemaData } from '$shared/lib/data/SchemaData';
import type { AddressModel } from '$provider/models/address/AddressModel';

export class AddressInputFormDataModel {
  public addressLine1 = '';
  public addressLine2 = '';
  public city = '';
  public state = '';
  public zipCode = '';
  public countryId = '';
  public type: AddressType = AddressType.Work;

  public stateLabel = '';
  public countryLabel = '';
  public errors: Partial<Record<keyof AddressInputFormDataModel, string>> = {};

  // Overidden on child class, if they want to hide for specific field
  public showTypeInput = false;
  public showCountryInput = false;

  public setAddressLine1(address: string): void {
    this.addressLine1 = address || '';
  }

  public setAddressLine2(address: string): void {
    this.addressLine2 = address || '';
  }

  public setCity(city: string): void {
    this.city = city || '';
  }

  public setState(item: CommonList): void {
    this.state = item.id as string;
    this.stateLabel = item.label;
  }

  public clearState(): void {
    this.state = '';
    this.stateLabel = '';
  }

  public setZipCode(zipCode: string): void {
    this.zipCode = zipCode || '';
  }

  public setCountry(item: CommonList): void {
    this.countryId = item.id as string;
    this.countryLabel = item.label;
  }

  public clearCountry(): void {
    this.countryId = '';
    this.countryLabel = '';
  }

  public setType(type: AddressType): void {
    this.type = type;
  }

  public validate(): void {
    this.resetError();
    AddressValidator.validateForm(this);
  }

  public resetError(): void {
    this.errors = {};
  }

  static getStatesAsList(): CommonList[] {
    return schemaData.getStateAsCommonlist();
  }

  static fromData(data: AddressModel): AddressInputFormDataModel {
    const form = new AddressInputFormDataModel();
    form.addressLine1 = data.addressLine1 || '';
    form.addressLine2 = data.addressLine2 || '';
    form.city = data.city || '';
    form.state = data.state || '';
    form.zipCode = data.zipCode || '';
    return form;
  }
}
